var _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite13Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 51,
    viewBox: "0 0 223 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.263 13.9993V37.6235H70.25V34.6384C69.4823 35.6618 68.4808 36.4647 67.2436 37.0482C66.007 37.6311 64.6633 37.9225 63.2136 37.9225C61.366 37.9225 59.7308 37.5314 58.3101 36.7499C56.8886 35.9684 55.7724 34.8164 54.9627 33.2953C54.1523 31.7742 53.7474 29.9623 53.7474 27.8583V13.9993H59.7178V27.0053C59.7178 28.8818 60.1865 30.3245 61.1248 31.3336C62.063 32.3426 63.3422 32.8471 64.9622 32.8471C66.6112 32.8471 67.9048 32.3426 68.843 31.3336C69.7813 30.3239 70.25 28.8818 70.25 27.0053V13.9993H76.263ZM80.6125 25.7262C80.6125 23.3383 81.0889 21.2199 82.0409 19.3723C82.9935 17.524 84.2871 16.1033 85.9216 15.108C87.5562 14.1127 89.3831 13.615 91.4012 13.615C93.1643 13.615 94.706 13.9704 96.0278 14.6811C97.3495 15.3918 98.4087 16.2875 99.2047 17.368V13.9993H105.218V37.6235H99.2047V34.1696C98.4369 35.2783 97.3784 36.1952 96.0278 36.9204C94.6771 37.6455 93.121 38.0078 91.3586 38.0078C89.3687 38.0078 87.5562 37.4964 85.9216 36.4729C84.2871 35.4494 82.9935 34.0067 82.0409 32.1446C81.0889 30.2826 80.6125 28.1429 80.6125 25.7268V25.7262ZM99.2054 25.8114C99.2054 24.3618 98.9208 23.1177 98.3524 22.0798C97.7839 21.0426 97.0162 20.2459 96.0498 19.6919C95.0833 19.1372 94.0454 18.8602 92.9367 18.8602C91.828 18.8602 90.8046 19.1303 89.8663 19.6706C88.9281 20.2109 88.1672 20.9993 87.585 22.0372C87.0022 23.0744 86.7107 24.304 86.7107 25.7262C86.7107 27.1476 87.0022 28.391 87.585 29.4571C88.1679 30.5232 88.9357 31.3405 89.8877 31.9089C90.8403 32.4773 91.8562 32.7619 92.9367 32.7619C94.0454 32.7619 95.0833 32.4842 96.0498 31.9302C97.0162 31.3755 97.7839 30.5796 98.3524 29.5423C98.9208 28.5051 99.2054 27.261 99.2054 25.8114ZM124.152 13.6584C126.966 13.6584 129.241 14.5471 130.975 16.3239C132.709 18.1007 133.576 20.5814 133.576 23.7652V37.6242H127.606V24.5755C127.606 22.6991 127.137 21.2563 126.199 20.2473C125.261 19.2383 123.982 18.7337 122.361 18.7337C120.712 18.7337 119.411 19.2383 118.459 20.2473C117.507 21.257 117.031 22.6991 117.031 24.5755V37.6242H111.061V14H117.031V16.9425C117.827 15.919 118.844 15.1162 120.08 14.5326C121.317 13.9498 122.674 13.6584 124.153 13.6584H124.152ZM146.199 18.9035V30.3321C146.199 31.128 146.391 31.7041 146.774 32.0594C147.158 32.4148 147.805 32.5921 148.715 32.5921H151.487V37.6242H147.734C142.702 37.6242 140.187 35.1793 140.187 30.2895V18.9035H137.373V14H140.187V8.15747H146.2V14H151.487V18.9035H146.2H146.199ZM178.096 14V37.6242H172.083V34.639C171.315 35.6625 170.314 36.4653 169.077 37.0489C167.84 37.6318 166.496 37.9232 165.047 37.9232C163.199 37.9232 161.564 37.5321 160.143 36.7506C158.722 35.9691 157.605 34.8171 156.796 33.296C155.985 31.7748 155.581 29.963 155.581 27.859V14H161.551V27.006C161.551 28.8825 162.02 30.3252 162.958 31.3343C163.896 32.3433 165.175 32.8478 166.795 32.8478C168.444 32.8478 169.738 32.3433 170.676 31.3343C171.614 30.3245 172.083 28.8825 172.083 27.006V14H178.096ZM213.319 13.659C216.219 13.659 218.557 14.5478 220.334 16.3246C222.111 18.1014 223 20.582 223 23.7658V37.6249H217.03V24.5762C217.03 22.7279 216.561 21.3141 215.623 20.3332C214.684 19.3524 213.405 18.8623 211.785 18.8623C210.165 18.8623 208.878 19.3524 207.926 20.3332C206.974 21.3141 206.497 22.7286 206.497 24.5762V37.6249H200.528V24.5762C200.528 22.7279 200.059 21.3141 199.121 20.3332C198.183 19.3524 196.903 18.8623 195.283 18.8623C193.634 18.8623 192.333 19.3524 191.381 20.3332C190.429 21.3141 189.953 22.7286 189.953 24.5762V37.6249H183.983V14.0007H189.953V16.858C190.721 15.8627 191.708 15.0812 192.917 14.5127C194.124 13.9436 195.454 13.6597 196.904 13.6597C198.752 13.6597 200.401 14.0508 201.85 14.8323C203.3 15.6138 204.423 16.7301 205.219 18.1797C205.987 16.8153 207.102 15.7204 208.566 14.8963C210.03 14.0714 211.615 13.6597 213.321 13.6597L213.319 13.659Z",
    fill: "#001E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5342 43.103C88.2078 43.103 88.8003 43.235 89.3117 43.4983C89.8231 43.7615 90.2183 44.1368 90.4967 44.6235C90.7757 45.1101 90.9146 45.6751 90.9146 46.3184C90.9146 46.9611 90.775 47.5234 90.4967 48.0045C90.2176 48.485 89.8231 48.8575 89.3117 49.1208C88.8003 49.384 88.2078 49.516 87.5342 49.516H85.2927V43.1037H87.5342V43.103ZM87.4881 48.4224C88.1617 48.4224 88.682 48.2389 89.0498 47.8712C89.4175 47.5035 89.601 46.9865 89.601 46.3184C89.601 45.651 89.4175 45.1286 89.0498 44.752C88.682 44.3753 88.1617 44.187 87.4881 44.187H86.5788V48.4217H87.4881V48.4224ZM105.188 43.103V49.5153H103.902V43.103H105.188ZM122.943 45.0324C122.796 44.763 122.594 44.5575 122.337 44.4173C122.08 44.2763 121.779 44.2062 121.436 44.2062C121.056 44.2062 120.719 44.2922 120.426 44.4633C120.132 44.6345 119.902 44.8798 119.737 45.1981C119.572 45.5163 119.489 45.8841 119.489 46.3006C119.489 46.7295 119.573 47.1027 119.741 47.4217C119.91 47.7399 120.144 47.9853 120.444 48.1564C120.744 48.3276 121.093 48.4135 121.491 48.4135C121.981 48.4135 122.382 48.2836 122.695 48.0231C123.007 47.7633 123.213 47.4003 123.31 46.935H121.106V45.9521H124.578V47.0732C124.492 47.5199 124.309 47.9337 124.027 48.3131C123.745 48.6926 123.382 48.9978 122.938 49.2273C122.494 49.4569 121.997 49.5717 121.445 49.5717C120.827 49.5717 120.268 49.4321 119.769 49.1538C119.27 48.8747 118.878 48.4877 118.593 47.9915C118.308 47.4952 118.165 46.9316 118.165 46.3013C118.165 45.6703 118.308 45.1053 118.593 44.6063C118.877 44.1073 119.27 43.7182 119.769 43.4392C120.268 43.1608 120.824 43.0212 121.436 43.0212C122.159 43.0212 122.787 43.1972 123.32 43.5498C123.852 43.9017 124.22 44.3966 124.422 45.0331H122.943V45.0324ZM138.842 43.103V49.5153H137.556V43.103H138.842ZM156.496 43.103V44.1409H154.787V49.5153H153.501V44.1409H151.793V43.103H156.496ZM173.387 48.2939H170.834L170.411 49.516H169.06L171.366 43.0941H172.863L175.169 49.516H173.81L173.387 48.2939ZM173.038 47.2649L172.11 44.5822L171.182 47.2649H173.038ZM189.341 48.496H191.454V49.5153H188.055V43.103H189.341V48.496Z",
    fill: "#336699"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_417_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5637 0C36.5774 0 47.1275 10.5495 47.1275 23.5638C47.1275 30.1809 44.3987 36.1588 40.0072 40.4396L36.2997 36.4832C39.5323 33.1709 41.5304 28.6055 41.5304 23.5644C41.5304 13.4487 33.4863 5.24793 23.5637 5.24793C13.6412 5.24793 5.59709 13.4487 5.59709 23.5644C5.59709 33.6802 13.6412 41.881 23.5637 41.881C27.8618 41.881 31.8072 40.3413 34.8989 37.7747L38.5913 41.7146C34.5126 45.0957 29.2756 47.1282 23.5637 47.1282C10.5501 47.1282 0 36.5781 0 23.5644C0 10.5501 10.5501 0.000688022 23.5637 0.000688022V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_417_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-5.7428 0.0743161L-4.85887 -0.989014L23.5638 23.5638Z",
    fill: "#F91C7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-5.00598 -0.811727L-4.24783 -1.67847L23.5638 23.5638Z",
    fill: "#F61D80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L-4.39905 -1.50507L-3.6196 -2.35327L23.5637 23.564Z",
    fill: "#F41F82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5639L-3.77563 -2.18423L-2.97555 -3.01318L23.5637 23.5639Z",
    fill: "#F22084"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-3.13562 -2.84679L-2.31493 -3.65649L23.5638 23.564Z",
    fill: "#EF2186"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-2.47925 -3.49437L-1.63931 -4.28345L23.5638 23.5639Z",
    fill: "#ED2288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5639L-1.80774 -4.1253L-0.948551 -4.89307L23.5637 23.5639Z",
    fill: "#EB238A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-1.12036 -4.73986L-0.242613 -5.48633L23.5638 23.5639Z",
    fill: "#E8248C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-0.417847 -5.33705L0.477773 -6.06152L23.5638 23.564Z",
    fill: "#E6268F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L0.29834 -5.91671L1.21114 -6.61987L23.5638 23.5638Z",
    fill: "#E42791"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L1.02905 -6.47891L1.95904 -7.15869L23.5638 23.5638Z",
    fill: "#E12893"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L1.77271 -7.02326L2.71919 -7.67969L23.5638 23.5638Z",
    fill: "#DF2995"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L2.53015 -7.54839L3.49244 -8.18213L23.5638 23.5639Z",
    fill: "#DD2A97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L3.30005 -8.05559L4.27746 -8.66528L23.5638 23.5639Z",
    fill: "#DA2B99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5641L4.08215 -8.54279L5.07468 -9.12842L23.5637 23.5641Z",
    fill: "#D82D9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L4.8761 -9.01186L5.88237 -9.57275L23.5638 23.5637Z",
    fill: "#D62E9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L5.68103 -9.46069L6.70107 -9.99683L23.5638 23.5638Z",
    fill: "#D32F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L6.49683 -9.88943L7.52923 -10.4001L23.5638 23.5639Z",
    fill: "#D130A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L7.32312 -10.2977L8.36791 -10.7837L23.5638 23.5639Z",
    fill: "#CF31A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L8.15894 -10.6862L9.21539 -11.146L23.5638 23.5638Z",
    fill: "#CC33A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L9.00366 -11.0541L10.0718 -11.4878L23.5638 23.5637Z",
    fill: "#CA34A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L9.85803 -11.4009L10.9358 -11.8079L23.5638 23.5639Z",
    fill: "#C835A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L10.72 -11.7266L11.8073 -12.1074L23.5638 23.564Z",
    fill: "#C536AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5639 23.5639L11.5902 -12.0313L12.6865 -12.3853L23.5639 23.5639Z",
    fill: "#C337AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L12.4672 -12.3144L13.5717 -12.6416L23.5638 23.5639Z",
    fill: "#C138AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L13.3512 -12.5758L14.4633 -12.8762L23.5638 23.5637Z",
    fill: "#BE3AB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5637L14.2412 -12.8157L15.3602 -13.0879L23.5637 23.5637Z",
    fill: "#BC3BB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L15.1362 -13.0334L16.2628 -13.2781L23.5638 23.5639Z",
    fill: "#BA3CB6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L16.0374 -13.2293L17.1687 -13.4465L23.5638 23.5639Z",
    fill: "#B73DB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5638L16.9425 -13.4033L18.0794 -13.5923L23.5637 23.5638Z",
    fill: "#B53EBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L17.8519 -13.5545L18.9929 -13.7153L23.5638 23.5638Z",
    fill: "#B33FBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L18.764 -13.6831L19.9092 -13.8171L23.5638 23.5638Z",
    fill: "#B041BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L19.6803 -13.7903L20.8275 -13.8948L23.5638 23.5638Z",
    fill: "#AE42C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L20.5979 -13.8739L21.7478 -13.9509L23.5638 23.564Z",
    fill: "#AC43C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L21.5176 -13.9353L22.6689 -13.9841L23.5638 23.5638Z",
    fill: "#A944C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L22.4386 -13.9745L23.5906 -13.9951L23.5638 23.5638Z",
    fill: "#A745C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5641L23.3596 -13.9907L24.5123 -13.9825L23.5638 23.5641Z",
    fill: "#A547C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L24.2814 -13.9846L25.4334 -13.9482L23.5638 23.564Z",
    fill: "#A248CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L25.2032 -13.9551L26.3531 -13.8911L23.5638 23.564Z",
    fill: "#A049CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L26.1235 -13.9036L27.2721 -13.8115L23.5638 23.5639Z",
    fill: "#9E4ACE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L27.0418 -13.8301L28.1877 -13.7091L23.5638 23.5639Z",
    fill: "#9B4BD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L27.9588 -13.7332L29.1011 -13.584L23.5638 23.5639Z",
    fill: "#994CD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L28.8729 -13.6143L30.0112 -13.4376L23.5638 23.5639Z",
    fill: "#974ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L29.7837 -13.4727L30.9171 -13.2678L23.5638 23.5639Z",
    fill: "#944FD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L30.6903 -13.3091L31.8189 -13.0761L23.5638 23.5639Z",
    fill: "#9250D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L31.5935 -13.1228L32.7159 -12.863L23.5638 23.5639Z",
    fill: "#9051DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L32.4912 -12.9146L33.6067 -12.6272L23.5638 23.5638Z",
    fill: "#8D52DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L33.3833 -12.6848L34.492 -12.3693L23.5638 23.564Z",
    fill: "#8B53DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L34.27 -12.4326L35.3705 -12.091L23.5638 23.5639Z",
    fill: "#8955E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L35.1505 -12.1592L36.242 -11.7901L23.5638 23.5638Z",
    fill: "#8656E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L36.0235 -11.8643L37.106 -11.4683L23.5638 23.5639Z",
    fill: "#8457E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L36.8895 -11.5474L37.9618 -11.1253L23.5638 23.5639Z",
    fill: "#8158E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L37.7473 -11.21L38.8086 -10.7618L23.5638 23.5638Z",
    fill: "#7F59E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L38.5962 -10.8511L39.6465 -10.3775L23.5638 23.5639Z",
    fill: "#7D5BEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L39.4362 -10.4724L40.474 -9.97272L23.5638 23.5638Z",
    fill: "#7A5CED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L40.2672 -10.0723L41.2927 -9.54712L23.5638 23.5639Z",
    fill: "#785DEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L41.0872 -9.65234L42.0996 -9.10246L23.5638 23.5639Z",
    fill: "#765EF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L41.8969 -9.2124L42.8956 -8.63708L23.5638 23.5639Z",
    fill: "#735FF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L42.6956 -8.75269L43.6799 -8.1533L23.5638 23.5638Z",
    fill: "#7160F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L43.4833 -8.27368L44.4524 -7.65027L23.5638 23.5637Z",
    fill: "#6F62F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L44.2586 -7.77441L45.212 -7.12762L23.5638 23.564Z",
    fill: "#6C63FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L45.0216 -7.25757L45.9591 -6.5874L23.5638 23.5639Z",
    fill: "#6B65FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L45.7715 -6.72144L46.6925 -6.02927L23.5638 23.5639Z",
    fill: "#6967FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L46.5076 -6.16748L47.4115 -5.45264L23.5638 23.5639Z",
    fill: "#6869F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L47.2307 -5.5957L48.1167 -4.85818L23.5638 23.5638Z",
    fill: "#666BF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L47.9394 -5.00586L48.8068 -4.24702L23.5638 23.5639Z",
    fill: "#656DF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L48.6329 -4.39893L49.4811 -3.61946L23.5638 23.5639Z",
    fill: "#636FF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L49.312 -3.77563L50.1403 -2.97557L23.5638 23.5637Z",
    fill: "#6271F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L49.9746 -3.1355L50.7836 -2.31481L23.5638 23.564Z",
    fill: "#6073F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L50.6221 -2.47925L51.4105 -1.63929L23.5638 23.5638Z",
    fill: "#5F75F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L51.2531 -1.80688L52.0209 -0.947696L23.5638 23.5639Z",
    fill: "#5D77F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L51.8676 -1.11963L52.614 -0.242569L23.5638 23.5638Z",
    fill: "#5C79F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L52.4649 -0.417725L53.1894 0.477896L23.5638 23.564Z",
    fill: "#5A7BF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L53.0443 0.29834L53.7468 1.21183L23.5638 23.5638Z",
    fill: "#597CF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L53.6066 1.02905L54.2864 1.95904L23.5638 23.5639Z",
    fill: "#577EF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L54.1503 1.77344L54.8074 2.71923L23.5638 23.5638Z",
    fill: "#5680F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L54.6761 2.53027L55.3098 3.49256L23.5638 23.5639Z",
    fill: "#5482F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L55.1827 3.30005L55.7924 4.27746L23.5638 23.5638Z",
    fill: "#5384F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L55.6707 4.08228L56.2563 5.07481L23.5638 23.5639Z",
    fill: "#5186F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L56.1395 4.87622L56.7003 5.88251L23.5638 23.5639Z",
    fill: "#5088F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L56.5876 5.68115L57.1244 6.70117L23.5638 23.564Z",
    fill: "#4E8AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L57.0165 6.49683L57.5279 7.52923L23.5638 23.5638Z",
    fill: "#4D8CF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L57.4255 7.32324L57.9114 8.36801L23.5638 23.564Z",
    fill: "#4C8EF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L57.8139 8.15894L58.2737 9.2154L23.5638 23.5639Z",
    fill: "#4A90F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L58.1816 9.00439L58.6153 10.0718L23.5638 23.5638Z",
    fill: "#4992F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L58.5287 9.85815L58.9363 10.9359L23.5638 23.5639Z",
    fill: "#4794F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L58.8545 10.7207L59.2353 11.8074L23.5638 23.5639Z",
    fill: "#4696F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L59.159 11.5901L59.513 12.6864L23.5638 23.5638Z",
    fill: "#4498F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L59.4422 12.4673L59.7694 13.5726L23.5638 23.5639Z",
    fill: "#439AF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L59.7034 13.3513L60.0031 14.4641L23.5638 23.564Z",
    fill: "#419CF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L59.9433 14.2415L60.2155 15.3612L23.5638 23.564Z",
    fill: "#409EF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L60.1612 15.137L60.4058 16.2628L23.5638 23.5639Z",
    fill: "#3EA0F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L60.357 16.0374L60.5742 17.1687L23.5638 23.5638Z",
    fill: "#3DA2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L60.531 16.9426L60.72 18.0795L23.5638 23.5639Z",
    fill: "#3BA4F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L60.6822 17.8518L60.843 18.9928L23.5638 23.5637Z",
    fill: "#3AA6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L60.8107 18.7646L60.944 19.9091L23.5638 23.5637Z",
    fill: "#38A8F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.9179 19.6804L61.0224 20.8276L23.5638 23.564Z",
    fill: "#37AAF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5641L61.0018 20.5981L61.0788 21.7474L23.5638 23.5641Z",
    fill: "#35ACF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L61.063 21.5176L61.1118 22.6689L23.5638 23.5638Z",
    fill: "#34AEF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L61.1021 22.4387L61.1228 23.5907L23.5638 23.5639Z",
    fill: "#32B0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L61.1186 23.3596L61.1104 24.5123L23.5638 23.5638Z",
    fill: "#31B2F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L61.1118 24.2816L61.076 25.4336L23.5638 23.564Z",
    fill: "#2FB4F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L61.0836 25.2033L61.019 26.3539L23.5638 23.564Z",
    fill: "#2EB6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L61.0313 26.1236L60.9392 27.2715L23.5638 23.564Z",
    fill: "#2CB8EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.9571 27.042L60.8368 28.1878L23.5638 23.564Z",
    fill: "#2BBAEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.8609 27.9589L60.7117 29.1013L23.5638 23.564Z",
    fill: "#29BCEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.742 28.873L60.5653 30.0113L23.5638 23.564Z",
    fill: "#28BEEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.6004 29.7838L60.3955 30.9172L23.5638 23.564Z",
    fill: "#26C0EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.4368 30.6904L60.2038 31.8191L23.5638 23.564Z",
    fill: "#25C2EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.2505 31.5936L59.99 32.716L23.5638 23.564Z",
    fill: "#23C4EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L60.0422 32.4913L59.7549 33.6068L23.5638 23.564Z",
    fill: "#22C6EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L59.8127 33.3842L59.4972 34.4921L23.5638 23.564Z",
    fill: "#20C8ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L59.5604 34.2701L59.2188 35.3706L23.5638 23.564Z",
    fill: "#1FCAED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L59.2868 35.1506L58.9177 36.2422L23.5638 23.564Z",
    fill: "#1DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L58.992 36.0236L58.5961 37.1062L23.5638 23.564Z",
    fill: "#1CCEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L58.6751 36.8896L58.2531 37.9619L23.5638 23.564Z",
    fill: "#1AD0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L58.3376 37.7475L57.8895 38.8087L23.5638 23.564Z",
    fill: "#19D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L57.9788 38.5963L57.5052 39.6466L23.5638 23.564Z",
    fill: "#17D4EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L57.6001 39.4363L57.1004 40.4748L23.5638 23.564Z",
    fill: "#16D6EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L57.2001 40.2666L56.6749 41.2921L23.5638 23.564Z",
    fill: "#14D8EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L56.7801 41.0873L56.2302 42.0997L23.5638 23.564Z",
    fill: "#13DAEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L56.3402 41.897L55.7655 42.8957L23.5638 23.564Z",
    fill: "#11DCEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L55.8803 42.6964L55.281 43.68L23.5638 23.564Z",
    fill: "#10DEEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L55.4013 43.4834L54.7778 44.4526L23.5638 23.564Z",
    fill: "#0EE0EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L54.9022 44.2587L54.2554 45.2121L23.5638 23.564Z",
    fill: "#0DE2EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L54.3854 45.0217L53.7152 45.9592L23.5638 23.564Z",
    fill: "#0EE0EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L53.8492 45.7716L53.1564 46.6919L23.5638 23.564Z",
    fill: "#10DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L53.2952 46.5084L52.5804 47.4116L23.5638 23.564Z",
    fill: "#11DCEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L52.7233 47.2308L51.9865 48.1162L23.5638 23.564Z",
    fill: "#13DAEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L52.1336 47.9395L51.3754 48.8062L23.5638 23.564Z",
    fill: "#14D8EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L51.5267 48.633L50.7472 49.4812L23.5638 23.564Z",
    fill: "#15D7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L50.9032 49.3114L50.1032 50.1411L23.5638 23.564Z",
    fill: "#17D5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L50.2626 49.9747L49.4426 50.7844L23.5638 23.564Z",
    fill: "#18D3EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L49.6069 50.6222L48.7669 51.4113L23.5638 23.564Z",
    fill: "#19D1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L48.9353 51.2532L48.0762 52.021L23.5638 23.564Z",
    fill: "#1BCFED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L48.248 51.8677L47.3702 52.6142L23.5638 23.564Z",
    fill: "#1CCDED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L47.5455 52.465L46.6499 53.1895L23.5638 23.564Z",
    fill: "#1ECBEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L46.8293 53.0444L45.9158 53.7476L23.5638 23.564Z",
    fill: "#1FC9EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L46.0986 53.6067L45.1687 54.2865L23.5638 23.564Z",
    fill: "#20C8EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L45.3542 54.1511L44.4078 54.8075L23.5638 23.564Z",
    fill: "#22C6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L44.5975 54.6762L43.6352 55.3099L23.5638 23.564Z",
    fill: "#23C4EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L43.8276 55.1835L42.8495 55.7932L23.5638 23.564Z",
    fill: "#24C2EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L43.0454 55.6708L42.0529 56.2564L23.5638 23.564Z",
    fill: "#26C0EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L42.2515 56.1389L41.2453 56.7005L23.5638 23.564Z",
    fill: "#27BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L41.4467 56.5884L40.4266 57.1245L23.5638 23.564Z",
    fill: "#29BCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L40.6308 57.0173L39.5984 57.528L23.5638 23.564Z",
    fill: "#2ABAF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L39.8046 57.4256L38.7598 57.9109L23.5638 23.564Z",
    fill: "#2BB8F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L38.9688 57.814L37.9123 58.2738L23.5638 23.564Z",
    fill: "#2DB7F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L38.1233 58.1817L37.0559 58.6154L23.5638 23.564Z",
    fill: "#2EB5F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L37.2696 58.5288L36.1919 58.9357L23.5638 23.564Z",
    fill: "#2FB3F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L36.4077 58.8546L35.3203 59.2354L23.5638 23.564Z",
    fill: "#31B1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L35.5375 59.1591L34.4412 59.5131L23.5638 23.564Z",
    fill: "#32AFF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L34.6604 59.4423L33.5552 59.7695L23.5638 23.564Z",
    fill: "#34ADF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L33.7765 59.7035L32.6637 60.0039L23.5638 23.564Z",
    fill: "#35ABF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L32.8864 59.9434L31.7667 60.2156L23.5638 23.564Z",
    fill: "#36A9F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L31.9908 60.1613L30.8649 60.406L23.5638 23.564Z",
    fill: "#38A7F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L31.0903 60.3572L29.959 60.5744L23.5638 23.564Z",
    fill: "#39A6F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L30.1851 60.5304L29.0482 60.7201L23.5638 23.564Z",
    fill: "#3AA4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L29.2757 60.6823L28.1347 60.8431L23.5638 23.564Z",
    fill: "#3CA2F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L28.3629 60.8108L27.2185 60.9442L23.5638 23.564Z",
    fill: "#3DA0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L27.4474 60.9174L26.3002 61.0225L23.5638 23.564Z",
    fill: "#3E9EF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L26.5298 61.0019L25.3798 61.0789L23.5638 23.564Z",
    fill: "#409CF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L25.6101 61.0631L24.4588 61.1119L23.5638 23.564Z",
    fill: "#419AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L24.689 61.1022L23.537 61.1222L23.5638 23.564Z",
    fill: "#4398F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L23.7672 61.1188L22.6152 61.1105L23.5638 23.564Z",
    fill: "#4496F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L22.8455 61.1119L21.6942 61.0761L23.5638 23.564Z",
    fill: "#4595F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L21.9244 61.083L20.7738 61.0191L23.5638 23.564Z",
    fill: "#4793F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L21.0042 61.0315L19.8556 60.9393L23.5638 23.564Z",
    fill: "#4891F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L20.0851 60.9579L18.9399 60.8369L23.5638 23.564Z",
    fill: "#498FF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L19.1689 60.861L18.0265 60.7119L23.5638 23.564Z",
    fill: "#4B8DF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L18.2547 60.7421L17.1165 60.5647L23.5638 23.564Z",
    fill: "#4C8BF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L17.3439 60.6005L16.2104 60.3957L23.5637 23.564Z",
    fill: "#4E89F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L16.4373 60.4362L15.3087 60.2039L23.5638 23.564Z",
    fill: "#4F87F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L15.5342 60.2506L14.4117 59.9908L23.5638 23.564Z",
    fill: "#5086F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L14.6364 60.0424L13.5209 59.755L23.5637 23.564Z",
    fill: "#5284F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L13.7436 59.8128L12.6356 59.4973L23.5638 23.564Z",
    fill: "#5382F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L12.857 59.5605L11.7572 59.2182L23.5638 23.564Z",
    fill: "#5480FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L11.9771 59.2869L10.8856 58.9179L23.5638 23.564Z",
    fill: "#567EFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L11.1042 58.9914L10.0216 58.5962L23.5638 23.564Z",
    fill: "#577CFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L10.2382 58.6752L9.16589 58.2532L23.5638 23.564Z",
    fill: "#597AFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L9.38037 58.3377L8.31909 57.8896L23.5638 23.564Z",
    fill: "#5A78FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L8.53148 57.9789L7.4812 57.5047L23.5638 23.564Z",
    fill: "#5B76FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L7.69155 57.6002L6.65295 57.0998L23.5638 23.564Z",
    fill: "#5D75FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L6.86048 57.2002L5.83496 56.675L23.5638 23.564Z",
    fill: "#5E73FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L6.04042 56.7802L5.02795 56.2303L23.5637 23.564Z",
    fill: "#5F71FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L5.23078 56.3403L4.23206 55.765L23.5638 23.564Z",
    fill: "#616FFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L4.43136 55.8805L3.44775 55.2811L23.5638 23.564Z",
    fill: "#626DFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L3.64433 55.4007L2.67517 54.7779L23.5638 23.564Z",
    fill: "#646BFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L2.86909 54.9024L1.91504 54.2556L23.5638 23.564Z",
    fill: "#6569FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L2.10612 54.3848L1.16858 53.7153L23.5638 23.564Z",
    fill: "#6667FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5639 23.564L1.35624 53.8493L0.435181 53.1565L23.5639 23.564Z",
    fill: "#6865FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L0.619375 53.2953L-0.283813 52.5805L23.5638 23.564Z",
    fill: "#6A64FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-0.103009 52.7234L-0.989014 51.9859L23.5638 23.564Z",
    fill: "#6C63FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-0.811754 52.1337L-1.6792 51.3749L23.5638 23.564Z",
    fill: "#6E62F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-1.50526 51.5268L-2.35413 50.7473L23.5638 23.564Z",
    fill: "#7161F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-2.18436 50.9033L-3.01331 50.1033L23.5638 23.564Z",
    fill: "#7360F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-2.84699 50.2627L-3.65601 49.4427L23.5638 23.564Z",
    fill: "#755EF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-3.49449 49.607L-4.28357 48.7671L23.5638 23.564Z",
    fill: "#775DF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-4.12541 48.9348L-4.89319 48.0756L23.5638 23.564Z",
    fill: "#7A5CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L-4.74 48.2474L-5.48645 47.3704L23.5637 23.564Z",
    fill: "#7C5BEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L-5.3373 47.5456L-6.06177 46.65L23.5637 23.564Z",
    fill: "#7E5AEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-5.91667 46.8294L-6.61914 45.9159L23.5638 23.564Z",
    fill: "#8159E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-6.47894 46.0988L-7.15942 45.1688L23.5638 23.564Z",
    fill: "#8358E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-7.02258 45.3544L-7.67969 44.4086L23.5638 23.564Z",
    fill: "#8556E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-7.54839 44.5976L-8.18213 43.6353L23.5638 23.564Z",
    fill: "#8755E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-8.055 43.8278L-8.66467 42.8503L23.5638 23.564Z",
    fill: "#8A54E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-8.54304 43.0456L-9.12866 42.053L23.5638 23.564Z",
    fill: "#8C53DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L-9.01188 42.2517L-9.57275 41.2454L23.5637 23.564Z",
    fill: "#8E52DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-9.46069 41.4468L-9.99683 40.4268L23.5638 23.564Z",
    fill: "#9151DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-9.88957 40.6309L-10.4003 39.5978L23.5638 23.564Z",
    fill: "#9350D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-10.2979 39.8047L-10.7838 38.7599L23.5638 23.564Z",
    fill: "#954ED6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-10.6862 38.9689L-11.146 37.9124L23.5638 23.564Z",
    fill: "#984DD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-11.0539 38.1234L-11.4877 37.056L23.5638 23.564Z",
    fill: "#9A4CD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-11.401 37.2697L-11.8086 36.192L23.5638 23.564Z",
    fill: "#9C4BD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-11.7269 36.4071L-12.1077 35.3197L23.5638 23.564Z",
    fill: "#9E4ACE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-12.0314 35.5376L-12.3854 34.4413L23.5638 23.564Z",
    fill: "#A149CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-12.3145 34.6606L-12.6417 33.5553L23.5638 23.564Z",
    fill: "#A348CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-12.5764 33.7766L-12.8754 32.6638L23.5638 23.564Z",
    fill: "#A546C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-12.8156 32.8865L-13.0885 31.7668L23.5638 23.564Z",
    fill: "#A845C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.0335 31.9909L-13.2782 30.865L23.5638 23.564Z",
    fill: "#AA44C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L-13.2295 31.0905L-13.4467 29.9584L23.5637 23.564Z",
    fill: "#AC43C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.4033 30.1852L-13.5923 29.0483L23.5638 23.564Z",
    fill: "#AE42C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.5545 29.2759L-13.7161 28.1348L23.5638 23.564Z",
    fill: "#B141BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.6838 28.363L-13.8164 27.2186L23.5638 23.564Z",
    fill: "#B33FBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.564L-13.7903 27.4475L-13.8955 26.3003L23.5637 23.564Z",
    fill: "#B53EBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.8742 26.5299L-13.9512 25.3799L23.5638 23.564Z",
    fill: "#B83DB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.936 25.6102L-13.9841 24.4589L23.5638 23.564Z",
    fill: "#BA3CB6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L-13.9745 24.6889L-13.9951 23.5369L23.5638 23.5637Z",
    fill: "#BC3BB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-13.991 23.7672L-13.9827 22.6152L23.5638 23.5638Z",
    fill: "#BE3AB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5639L-13.9849 22.8456L-13.9484 21.6943L23.5637 23.5639Z",
    fill: "#C139B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-13.9559 21.9245L-13.8913 20.7739L23.5638 23.5639Z",
    fill: "#C337AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-13.9044 21.0043L-13.8116 19.8557L23.5638 23.564Z",
    fill: "#C536AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L-13.8302 20.0857L-13.7092 18.9392L23.5638 23.5637Z",
    fill: "#C835AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5639L-13.7333 19.169L-13.5848 18.0266L23.5637 23.5639Z",
    fill: "#CA34A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5639 23.5638L-13.6143 18.2547L-13.4376 17.1165L23.5639 23.5638Z",
    fill: "#CC33A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5637L-13.4728 17.3439L-13.2679 16.2104L23.5637 23.5637Z",
    fill: "#CE32A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5639L-13.3092 16.4368L-13.0769 15.3088L23.5637 23.5639Z",
    fill: "#D131A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5639L-13.1229 15.5343L-12.8631 14.4119L23.5637 23.5639Z",
    fill: "#D32F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-12.9153 14.6366L-12.6273 13.521L23.5638 23.5639Z",
    fill: "#D52E9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L-12.6851 13.7435L-12.3703 12.6355L23.5638 23.5637Z",
    fill: "#D82D9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-12.4327 12.8571L-12.0911 11.7573L23.5638 23.564Z",
    fill: "#DA2C99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-12.1592 11.9773L-11.7901 10.8857L23.5638 23.5639Z",
    fill: "#DC2B97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5637 23.5637L-11.8644 11.1034L-11.4685 10.0215L23.5637 23.5637Z",
    fill: "#DF2A95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-11.5481 10.2383L-11.1254 9.16602L23.5638 23.564Z",
    fill: "#E12993"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-11.21 9.38036L-10.7618 8.31909L23.5638 23.5638Z",
    fill: "#E32791"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-10.8518 8.53146L-10.3775 7.4812L23.5638 23.5638Z",
    fill: "#E5268F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-10.4724 7.69167L-9.97271 6.65308L23.5638 23.564Z",
    fill: "#E8258D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-10.0724 6.86117L-9.54726 5.83496L23.5638 23.5638Z",
    fill: "#EA248B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-9.65247 6.04054L-9.10259 5.02808L23.5638 23.5639Z",
    fill: "#EC2389"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-9.21252 5.23021L-8.63791 4.23218L23.5638 23.5639Z",
    fill: "#EF2287"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L-8.75269 4.4313L-8.15332 3.44702L23.5638 23.5637Z",
    fill: "#F12185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-8.27356 3.64446L-7.65013 2.67529L23.5638 23.5639Z",
    fill: "#F31F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5639L-7.77527 2.86912L-7.12848 1.91577L23.5638 23.5639Z",
    fill: "#F51E81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5637L-7.25769 2.10601L-6.58752 1.16846L23.5638 23.5637Z",
    fill: "#F81D7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.564L-6.72156 1.35639L-6.02872 0.436035L23.5638 23.564Z",
    fill: "#FA1C7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5638 23.5638L-6.1676 0.619379L-5.59572 -0.103027L23.5638 23.5638Z",
    fill: "#FB1B7C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5637 36.4522C30.6135 36.4522 36.3285 30.6815 36.3285 23.563C36.3285 16.4445 30.6135 10.6738 23.5637 10.6738C16.5139 10.6738 10.799 16.4445 10.799 23.563C10.799 30.6815 16.5139 36.4522 23.5637 36.4522Z",
    fill: "url(#paint0_linear_417_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8015 50.6846C46.2899 50.6846 48.3071 48.6477 48.3071 46.135C48.3071 43.6224 46.2899 41.5854 43.8015 41.5854C41.3131 41.5854 39.2959 43.6224 39.2959 46.135C39.2959 48.6477 41.3131 50.6846 43.8015 50.6846Z",
    fill: "#10DEEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_417_3",
    x1: 19.2424,
    y1: 15.9011,
    x2: 30.8792,
    y2: 31.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#597AFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite13Logo);
export default __webpack_public_path__ + "static/media/website-13-logo.a8c2b18549dccbe9d15499594d0f146f.svg";
export { ForwardRef as ReactComponent };